var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultLaterImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 650,
    height: 650,
    viewBox: "0 0 650 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 650,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390.205,
    height: 461.317,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Shadow_08dp",
    x: 122,
    y: 104.337,
    width: 390.205,
    height: 461.317,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.141
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327.29,
    height: 396.263,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Shadow_03dp",
    x: 154.24,
    y: 131.737,
    width: 327.29,
    height: 396.263,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.141
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_29_1",
    "data-name": "Component 29 \\u2013 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M325,0C504.493,0,650,145.507,650,325S504.493,650,325,650c-73.771,0-141.8-24.579-197.877-67.162C50.48,524.653,0,430.721,0,325,0,145.507,145.507,0,325,0Z",
    fill: "#2962ff",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    "data-name": "Group 1270",
    transform: "translate(-694.469 -152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_08dp-2",
    "data-name": "Shadow / 08dp",
    transform: "translate(816.469 256.337)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -122, -104.34)",
    filter: "url(#Shadow_08dp)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shadow_08dp-3",
    "data-name": "Shadow / 08dp",
    width: 360.205,
    height: 431.317,
    rx: 2,
    transform: "translate(137 111.34)",
    fill: "#2962ff",
    opacity: 0.08
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_03dp-2",
    "data-name": "Shadow / 03dp",
    transform: "translate(848.71 283.737)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -154.24, -131.74)",
    filter: "url(#Shadow_03dp)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_03dp-3",
    "data-name": "Shadow / 03dp",
    transform: "translate(160.24 134.74)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H313.29a2,2,0,0,1,2,2V382.263a2,2,0,0,1-2,2l-256-.814-24-22.186c-.474,0-1.605-1.645-3.436-3.4-1.907-1.826-4.564-3.969-4.564-4.6L0,329.938V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.999969482421875 2.999969482421875 L 2.999969482421875 328.6239318847656 L 27.32391357421875 351.0574340820313 L 28.29000854492188 351.948486328125 L 28.29000854492188 352.3319396972656 C 28.76629638671875 352.80859375 29.54412841796875 353.5110473632813 30.10916137695313 354.0212707519531 C 30.71762084960938 354.5707397460938 31.34683227539063 355.138916015625 31.93002319335938 355.6972351074219 C 32.78387451171875 356.515869140625 33.47702026367188 357.2871704101563 34.03396606445313 357.9068908691406 C 34.13653564453125 358.0210266113281 34.24789428710938 358.1449584960938 34.35494995117188 358.2627258300781 L 34.4642333984375 358.2627258300781 L 35.326416015625 359.0597839355469 L 58.46820068359375 380.4519958496094 L 312.2900085449219 381.259521484375 L 312.2900085449219 2.999969482421875 L 2.999969482421875 2.999969482421875 M 1.999969482421875 -3.0517578125e-05 L 313.2900085449219 -3.0517578125e-05 C 314.3946228027344 -3.0517578125e-05 315.2900085449219 0.895416259765625 315.2900085449219 1.999969482421875 L 315.2900085449219 382.2627258300781 C 315.2900085449219 383.3673400878906 314.3946228027344 384.2627258300781 313.2900085449219 384.2627258300781 L 57.29000854492188 383.4482727050781 L 33.29000854492188 361.2627258300781 C 32.816162109375 361.2627258300781 31.68466186523438 359.6180725097656 29.85382080078125 357.8627319335938 C 27.94631958007813 356.03662109375 25.29000854492188 353.8934936523438 25.29000854492188 353.2627258300781 L -3.0517578125e-05 329.938232421875 L -3.0517578125e-05 1.999969482421875 C -3.0517578125e-05 0.895416259765625 0.895416259765625 -3.0517578125e-05 1.999969482421875 -3.0517578125e-05 Z",
    stroke: "none",
    fill: "rgba(41,98,255,0.15)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 232,
    height: 41,
    rx: 14,
    transform: "translate(896 263)",
    fill: "#2962ff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    transform: "translate(952 240)",
    fill: "#2962ff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0H111a9,9,0,0,1,9,9V24a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9A9,9,0,0,1,9,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,.5H111A8.5,8.5,0,0,1,119.5,9V23a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,23V9A8.5,8.5,0,0,1,9,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2120",
    "data-name": "Path 2120",
    transform: "translate(880.242 587) rotate(41)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.993,1.052,78.5,41.9-.369,38.746Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 42.69754791259766 5.28399658203125 L 7.305007934570313 36.05025863647461 L 71.67765045166016 38.62180709838867 L 42.69754791259766 5.28399658203125 M 42.99349975585938 1.05169677734375 L 78.49952697753906 41.89672088623047 L -0.3689498901367188 38.74609756469727 L 42.99349975585938 1.05169677734375 Z",
    stroke: "none",
    fill: "rgba(41,98,255,0.15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    transform: "translate(888 352)",
    fill: "#2962ff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    x2: 184,
    transform: "translate(952 360)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    x2: 144,
    transform: "translate(952 376)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M0,0H72",
    transform: "translate(952 392)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267",
    transform: "translate(0 72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_527-2",
    "data-name": "Rectangle 527",
    transform: "translate(888 352)",
    fill: "#2962ff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_158-2",
    "data-name": "Line 158",
    x2: 184,
    transform: "translate(952 360)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159-2",
    "data-name": "Line 159",
    x2: 144,
    transform: "translate(952 376)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121-2",
    "data-name": "Path 2121",
    d: "M0,0H72",
    transform: "translate(952 392)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268",
    transform: "translate(0 144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_527-3",
    "data-name": "Rectangle 527",
    transform: "translate(888 352)",
    fill: "#2962ff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_158-3",
    "data-name": "Line 158",
    x2: 184,
    transform: "translate(952 360)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159-3",
    "data-name": "Line 159",
    x2: 144,
    transform: "translate(952 376)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121-3",
    "data-name": "Path 2121",
    d: "M0,0H72",
    transform: "translate(952 392)",
    fill: "none",
    stroke: "#2962ff",
    strokeWidth: 2,
    opacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    transform: "translate(1008 488)",
    fill: "#fff",
    stroke: "rgba(41,98,255,0.15)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 72,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 70.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    transform: "translate(1019 499)",
    fill: "#2962ff",
    stroke: "#2962ff",
    strokeWidth: 1,
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 61,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 60.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    "data-name": "Line 160",
    x2: 27,
    y2: 46,
    transform: "translate(1117 620)",
    fill: "none",
    stroke: "rgba(41,98,255,0.15)",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    x2: 45,
    transform: "translate(1024 536)",
    fill: "none",
    stroke: "rgba(41,98,255,0.1)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M0,0H69",
    transform: "translate(1035 520)",
    fill: "none",
    stroke: "rgba(41,98,255,0.1)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2124",
    "data-name": "Path 2124",
    transform: "translate(1136 680)",
    fill: "rgba(41,98,255,0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.708-13.119l8.762-4.762L48,32,32,40Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.17993545532227 -16.58471298217773 L 4.069660186767578 -12.72041702270508 L 32.411865234375 38.67603302001953 L 46.4933967590332 31.6352653503418 L 11.17993545532227 -16.58471298217773 M 11.47033309936523 -17.88067626953125 L 47.99999618530273 32 L 31.9999942779541 40 L 2.708126068115234 -13.11858749389648 L 11.47033309936523 -17.88067626953125 Z",
    stroke: "none",
    fill: "rgba(41,98,255,0.15)"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "matrix(0.899, -0.438, 0.438, 0.899, 560.067, 293.214)",
    fontSize: 48,
    fontFamily: "Roboto-Regular, Roboto",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "+",
    transform: "translate(450 73)",
    fontSize: 29,
    fontFamily: "Roboto-Regular, Roboto",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    transform: "translate(82 176)",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    transform: "translate(58 368)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0.2)",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    transform: "translate(538 472)",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultLaterImg);
export default __webpack_public_path__ + "static/media/result_later-img.ca1ca2bd99871c626f3ba69a51367b67.svg";
export { ForwardRef as ReactComponent };